import React from "react";
import { driversClub, ironsClub } from "../../../../../../constants/clubs";
import { useSwingLibrarySettings } from "../../../../../../hooks/useSwingLibrarySettings";
import SelectGolfers from "../../../../../../components/FiltersRow/components/SelectGolfers";
import { SelectClub } from "../../../../../../components/FiltersRow/components/SelectClub";
import { SelectTags } from "../../../../../../components/FiltersRow/components/SelectTags";
import { useMiniSwingLibraryStore } from "../../../../store/miniSwingLibraryStore";

const Filters = () => {
  const { activeFilters, pagination, setActiveFilters, setPagination } =
    useMiniSwingLibraryStore();
  const { data: swingLibrarySettings } = useSwingLibrarySettings();

  const handleFilterValueChange = (filterName, value) => {
    switch (filterName) {
      case "club":
        setActiveFilters({ club: value });
        break;
      case "golfer": {
        const exists = activeFilters.users.some(
          (u) => u.userId === value.userId
        );
        setActiveFilters({
          users: exists
            ? activeFilters.users.filter((u) => u.userId !== value.userId)
            : [...activeFilters.users, value],
        });
        break;
      }
      case "tags": {
        const exists = activeFilters.tags.some((u) => u === value);
        setActiveFilters({
          tags: Array.isArray(value)
            ? value
            : exists
            ? activeFilters.tags.filter((u) => u !== value)
            : [...activeFilters.tags, value],
        });
        break;
      }
      default:
        break;
    }

    if (pagination.page !== 1) setPagination({ page: 1 });
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <SelectGolfers
        header="Golfers"
        onOptionSelect={(value) => handleFilterValueChange("golfer", value)}
        placeholder="Golfer"
        values={activeFilters.users}
      />

      <SelectClub
        onChange={(value) => handleFilterValueChange("club", value)}
        options={[
          {
            label: "Woods & Hybrids",
            options: driversClub.map((club) => ({ text: club, value: club })),
          },
          {
            label: "Irons & Wedges",
            options: ironsClub.map((club) => ({ text: club, value: club })),
          },
        ]}
        placeholder="Club"
        values={activeFilters.club}
      />

      <SelectTags
        header="Tags"
        onChange={(value) => handleFilterValueChange("tags", value)}
        onClear={() => handleFilterValueChange("tags", [])}
        options={swingLibrarySettings?.tags || []}
        placeholder="Tags"
        values={activeFilters.tags}
      />
    </div>
  );
};

export default Filters;
